import {Component, Inject, OnDestroy} from "@angular/core";
import {DOCUMENT} from "@angular/common";
import {LoginModel} from "./service/login.model";
import {Observable} from "rxjs";
import {AngularFirestore, AngularFirestoreCollection} from "angularfire2/firestore";
import {Md5} from "ts-md5";
import {LocalStorageService} from "ngx-webstorage";
import {ToastyService} from "ng2-toasty";
import {Router} from "@angular/router";
import {UserModel} from "../public/service/user.model";
import {NgProgressService} from "ng2-progressbar";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnDestroy {
  private userCollection: AngularFirestoreCollection<UserModel>;
  items: Observable<UserModel[]>;

  login: LoginModel = <LoginModel>{};

  constructor(private db: AngularFirestore,
              private toastyService: ToastyService,
              private localSt: LocalStorageService,
              private router: Router,
              private pService: NgProgressService,
              @Inject(DOCUMENT) private document: Document) {
    document.body.classList.add('loginPage');
  }

  ngOnDestroy() {
    document.body.classList.remove('loginPage');
  }

  validateLogin() {
    this.pService.start();
    const password = Md5.hashStr(this.login.password);
    console.log(password);
    this.userCollection = this.db.collection<UserModel>('users', ref =>
      ref.where('username', '==', this.login.username)
        .where('password', '==', password));
    //noinspection TypeScriptValidateTypes
    this.items = this.userCollection.snapshotChanges().map(res => res.map(a => {
      const data = a.payload.doc.data() as UserModel;
      console.log('datauser', data);
      const id = a.payload.doc.id;
      return {id, ...data};
    }));
    this.items.subscribe(elements => {
      this.pService.done();
      if (elements && elements.length > 0) {
        const usr = elements[0];
        console.log(usr);
        this.localSt.store('usr-ss', usr);
        if (usr.is_client)
          this.router.navigate(['public']);
        else
          this.router.navigate(['app/reports']);
      } else {
        // this.toastyService.error('El usuario no fue encontrado');
      }
    }, err => console.log(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts